<template>
  <div class="profil-container" v-if="afiliasi && afiliasi.length > 0">
    <h3 class="profil-title">
      <span v-if="isEdit" class="editRow" @click="editRow(afiliasi[0])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ afiliasi[0].text }}
    </h3>
    <p class="profil-subtitle">
      <span v-if="isEdit" class="editRow" @click="editRow(afiliasi[1])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ afiliasi[1].text }}
    </p>

    <div class="vendor-form-wrapper">
      <div v-for="(item, index) in afiliasi.slice(2)" :key="index" class="vendor-form">
        <span v-if="isEdit" class="editRow" @click="editRow(item)"><span class="fa fa-edit pointer ml20"></span></span>

        <p class="vendor-form-label">{{ item.text }}<span v-if="item.is_mandatory" class="text-ast">*</span></p>

        <div v-if="item.name === 'Afiliation-3' || item.name === 'Afiliation-4'" class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column15">Jabatan</p>
              <p class="column20">Nama</p>
              <p class="column20">No. HP</p>
              <p class="column20">Email</p>
              <p class="column10">KTP</p>
            </div>
          </div>
          <div class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <div v-if="item.name === 'Afiliation-5'" class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column40">Nama Pemegang Saham</p>
              <p class="column50">% Saham</p>
            </div>
          </div>
          <div class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <div v-if="item.name === 'Afiliation-6'" class="form-list-usaha">
          <div class="list-usaha">
            <div class="list-usaha-content list-usaha-content__title">
              <p class="column50">Nama</p>
              <p class="column20">No. Handphone</p>
              <p class="column20">Email</p>
            </div>
          </div>
          <div class="btn-landing-icons">
            <p class="icons-btn-landing">+</p>
            <p class="text-btn-landing">Tambah</p>
          </div>
        </div>

        <div v-if="item.name === 'Afiliation-7'" class="vendor-form">
          <div class="input-20">
            <input type="radio" name="ya" value="ya" v-model="pick" />
            <label class="ml20" for="ya">Ya</label>
          </div>
          <div class="input-20">
            <input type="radio" name="tidak" value="tidak" v-model="pick" />
            <label class="ml20" for="tidak">Tidak</label>
          </div>
        </div>

        <input v-if="item.question_type !== 'default' && item.question_type === 'text'" type="text"
          class="vendor-input" />
        <textarea v-if="item.question_type !== 'default' && item.question_type === 'textarea'" class="vendor-input" />
        <div class="vendor-input flex-row" v-if="item.question_type !== 'default' && item.question_type === 'radio'">
          <div class="input-20">
            <input type="radio" name="ya" value="ya" v-model="item.value" />
            <label class="ml20" for="ya">Ya</label>
          </div>
          <div class="input-20">
            <input type="radio" name="tidak" value="tidak" v-model="item.value" />
            <label class="ml20" for="tidak">Tidak</label>
          </div>
        </div>
        <input v-if="item.question_type !== 'default' && item.question_type === 'date-picker'" type="date"
          class="vendor-input" />
        <div v-if="item.question_type !== 'default' && item.question_type === 'date-range'" class="vendor-input">
          <input type="date" class="w-50" />
          <input type="date" class="w-50" />
        </div>
        <input v-if="item.question_type !== 'default' && item.question_type === 'attachment'" type="file"
          class="vendor-input" />

      </div>

      <!-- <div v-if="pick == 'ya'">
        <div class="vendor-form">
          <div class="input-20">
            <input type="checkbox" value="1" v-model="afiliasi_gems" />
            <label class="ml20">GEMS</label>
          </div>
          <div class="input-20">
            <input type="checkbox" value="1" v-model="afiliasi_bce" />
            <label class="ml20">BCE</label>
          </div>
          <div class="input-20">
            <input type="checkbox" value="1" v-model="afiliasi_bkes" />
            <label class="ml20">BKES</label>
          </div>
        </div>
      </div> -->

      <!-- <div class="vendor-form100" v-if="pick == 'ya'">
        <div>
          <div class="vendor-form100">
            <div class="label-100">
              Jelaskan hubungan dengan Sinarmas Mining Group!<span class="text-ast">*</span>
            </div>
            <textarea class="input-100" v-model="relasi_desc"
              oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
          </div>

          <div class="vendor-form100">
            <div class="label-100">
              Apa nama Group Keluarga Anda di Sinarmas Mining Group?
            </div>
            <textarea class="input-100" v-model="relasi_group"
              oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
          </div>

          <div class="vendor-form100">
            <div class="label-100 mb10">
              Identitas Nama Orang yang Bersangkutan dengan Anda
            </div>
            <div class="vendor-form">
              <p class="vendor-form-label">Nama</p>
              <input type="text" class="vendor-input" v-model="relasi_nama"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
            </div>

            <div class="vendor-form">
              <p class="vendor-form-label">Jabatan</p>
              <input type="text" class="vendor-input" v-model="relasi_jabatan"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
            </div>

            <div class="vendor-form">
              <p class="vendor-form-label">Departemen</p>
              <input type="text" class="vendor-input" v-model="relasi_departemen"
                oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
            </div>
          </div>
        </div>
      </div> -->


    </div>

    <div class="btn-landing-icons" @click="addQuestion">
      <p class="icons-btn-landing">+</p>
      <span class="text-btn-landing">Tambah</span>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goLegalitas()" class="btn-landing">Selanjutnya</div>
    </div>

    <addDirektur v-if="
      $store.state.landingpage.addDirektur ||
      $store.state.landingpage.editDirektur
    " />
    <addKomisaris v-if="
      $store.state.landingpage.addKomisaris ||
      $store.state.landingpage.editKomisaris
    " />
    <addPemilikSaham v-if="
      $store.state.landingpage.addPemilikSaham ||
      $store.state.landingpage.editPemilikSaham
    " />
    <addPic v-if="$store.state.landingpage.addPic || $store.state.landingpage.editPic" />

    <EditPertanyaan v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
    <AddPertanyaan v-if="showModalAdd" @closeModal="closeModalAdd" class="notAll" />
  </div>
</template>

<script>
export default {
  name: 'alamat',
  components: {
    addDirektur: () => import('@/components/modalLandingPage/addDirektur.vue'),
    addKomisaris: () => import('@/components/modalLandingPage/addKomisaris.vue'),
    addPemilikSaham: () => import('@/components/modalLandingPage/addPemilikSaham.vue'),
    addPic: () => import('@/components/modalLandingPage/addPic.vue'),

    EditPertanyaan: () => import('@/components/masterdata/landing-page/edit/edit-pertanyaan.vue'),
    AddPertanyaan: () => import('@/components/masterdata/landing-page/add/tambah-pertanyaan.vue'),
  },
  props: {
    isEdit: Boolean
  },
  data() {
    return {
      showModalEdit: false,
      showModalAdd: false,
      editData: null,
    }
  },
  computed: {
    afiliasi() {
      const data = this.$store.state.mdLandingStore.afiliasi
      return data
    },
    pick: {
      get() {
        return this.$store.state.landingpage.pick
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pick',
          value: newValue,
        })
      },
    },
    afiliasi_gems: {
      get: function () {
        return this.$store.state.landingpage.afiliasi_gems
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_gems',
          value: newValue,
        })
      },
    },
    afiliasi_bce: {
      get: function () {
        return this.$store.state.landingpage.afiliasi_bce
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_bce',
          value: newValue,
        })
      },
    },
    afiliasi_bkes: {
      get: function () {
        return this.$store.state.landingpage.afiliasi_bkes
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_bkes',
          value: newValue,
        })
      },
    },
    direkturList: function () {
      return this.$store.state.landingpage.direkturList
    },
    komisarisList: function () {
      return this.$store.state.landingpage.komisarisList
    },
    pemilikSahamList: function () {
      return this.$store.state.landingpage.pemilikSahamList
    },
    picList: function () {
      return this.$store.state.landingpage.picList
    },
    relasi_desc: {
      get() {
        return this.$store.state.landingpage.relasi_desc
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_desc',
          value: newValue,
        })
      },
    },
    relasi_group: {
      get() {
        return this.$store.state.landingpage.relasi_group
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_group',
          value: newValue,
        })
      },
    },
    relasi_nama: {
      get() {
        return this.$store.state.landingpage.relasi_nama
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_nama',
          value: newValue,
        })
      },
    },
    relasi_jabatan: {
      get() {
        return this.$store.state.landingpage.relasi_jabatan
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_jabatan',
          value: newValue,
        })
      },
    },
    relasi_departemen: {
      get() {
        return this.$store.state.landingpage.relasi_departemen
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'relasi_departemen',
          value: newValue,
        })
      },
    },
  },
  methods: {
    editRow(data) {
      this.editData = data
      this.showModalEdit = true
    },
    addQuestion() {
      this.showModalAdd = true;
    },

    closeModalAdd() {
      this.showModalAdd = false;
    },

    closeModal() {
      this.showModalEdit = false
    },

    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
    },
    goLegalitas() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitasbu')
    },
    openDirekturModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addDirektur',
        value: true,
      })
    },
    editDirektur(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idDirektur',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'jabatanDirektur',
        value: list.jabatan,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaDirektur',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phoneDirektur',
        value: list.phoneNumber,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailDirektur',
        value: list.email,
      })
      if (list.lampiran) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'direkturLampiran',
          value: list.lampiran,
        })
      }
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'direkturFiles',
        value: list.direkturFiles,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editDirektur',
        value: true,
      })
    },
    deleteDirektur(list, index) {
      let deleted = {
        ...list,
        isDelete: true,
      }
      if (list.jabatan == 'DIREKTUR UTAMA') {
        this.$store.commit('SET_NOTIF', 'Direktur Utama hanya bisa di edit.')
      } else {
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'direkturList',
          value: list.id,
          index,
          deleted,
          operation: 'delete',
        })
      }
    },
    openKomisarisModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addKomisaris',
        value: true,
      })
    },
    editKomisaris(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idKomisaris',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'jabatanKomisaris',
        value: list.jabatan,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaKomisaris',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phoneKomisaris',
        value: list.phoneNumber,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailKomisaris',
        value: list.email,
      })
      if (list.lampiran) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'komisarisLampiran',
          value: list.lampiran,
        })
      }
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'komisarisFiles',
        value: list.komisarisFiles,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editKomisaris',
        value: true,
      })
    },
    deleteKomisaris(list, index) {
      let deleted = {
        ...list,
        isDelete: true,
      }
      if (list.jabatan == 'KOMISARIS UTAMA') {
        this.$store.commit('SET_NOTIF', 'Komisaris Utama hanya bisa di edit.')
      } else {
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'komisarisList',
          value: list.id,
          deleted,
          index,
          operation: 'delete',
        })
      }
    },
    openPemilikSahamModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPemilikSaham',
        value: true,
      })

      if (this.$store.state.landingpage.pemilikSahamList.length > 0) {
        let totalSaham = this.$sum(
          this.$store.state.landingpage.pemilikSahamList,
          'saham'
        )

        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'totalSaham',
          value: Number(totalSaham),
        })
      }
    },
    editPemilikSaham(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idPemilikSaham',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaPemilikSaham',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'sahamPemilikSaham',
        value: list.saham,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPemilikSaham',
        value: true,
      })

      if (this.$store.state.landingpage.pemilikSahamList.length > 0) {
        let totalSaham = this.$sum(
          this.$store.state.landingpage.pemilikSahamList,
          'saham'
        )

        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'totalSaham',
          value: Number(totalSaham) - Number(list.saham),
        })
      }
    },
    deletePemilikSaham(list) {
      this.$store.commit('landingpage/SET_ARRAY_DATA', {
        name: 'pemilikSahamList',
        value: list.id,
        operation: 'delete',
      })
    },
    openPicModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addPic',
        value: true,
      })
    },
    editPic(list) {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'idPic',
        value: list.id,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaPic',
        value: list.nama,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phonePic',
        value: list.phoneNumber,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailPic',
        value: list.email,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editPic',
        value: true,
      })
    },
    deletePic(list) {
      this.$store.commit('landingpage/SET_ARRAY_DATA', {
        name: 'picList',
        value: list.id,
        operation: 'delete',
      })
    },
  },
}
</script>
